module.exports = __webpack_public_path__ + "img/abyss_custom_logo.f50f4024.svg";